import React, { useContext } from 'react';
import '../../../styles/dashboard_main_page.css';
import { DashboardContext } from '../../../contexts/states/DashboardState';
import { formattedDate, formattedMonth } from '../../../contexts/utils';
import { GlobalLoading } from '../../Layouts/GlobalLoading';

export const DashboardPage = () => {
  const { initLoading, feedbacks, users, drivers, rides, ridesRealtimeStat } =
    useContext(DashboardContext);

  return (
    <div className='main'>
      {initLoading && (
        <div className='background-overlay active' onClick={null}>
          <GlobalLoading />
        </div>
      )}
      <header className='desktop'>
        <h2>Overall Stats</h2>
      </header>
      <main>
        <div className='cards'>
          <div className='cards-con'>
            <div className='main-card'>
              <div className='card-icon'>
                <i className='fas fa-user'></i>
              </div>
              <div className='card-name'>
                <p>Users</p>
              </div>
              <div className='number'>
                <span className='big'>{users.length}</span>
              </div>
            </div>
            <div className='main-card'>
              <div className='card-icon'>
                <i className='fas fa-car'></i>
              </div>
              <div className='card-name'>
                <p>Rides</p>
              </div>
              <div className='number'>
                <span className='big'>{rides.length}</span>
              </div>
            </div>
            <div className='main-card'>
              <div className='card-icon'>
                <i className='fas fa-user-tie'></i>
              </div>
              <div className='card-name'>
                <p>Drivers</p>
              </div>
              <div className='number'>
                <span className='big'>{drivers.length}</span>
              </div>
            </div>
            <div className='main-card'>
              <div className='card-icon'>
                <i className='fas fa-comments'></i>
              </div>
              <div className='card-name'>
                <p>Feedbacks</p>
              </div>
              <div className='number'>
                <span className='big'>{feedbacks.length}</span>
              </div>
            </div>
          </div>
        </div>
        <div className='list'>
          <h3>RealTime</h3>
          <div className='main-list'>
            <div className='icon'>
              <i className='fas fa-home'></i>
            </div>
            <div>
              <p className='big'>Rides Today</p>
              <p className='small'>{formattedDate}</p>
            </div>
            <div className='number'>
              <p>{ridesRealtimeStat.today}</p>
            </div>
          </div>
          <div className='main-list'>
            <div className='icon'>
              <i className='fas fa-user'></i>
            </div>
            <div>
              <p className='big'>Rides of the Month</p>
              <p className='small'>Month of {formattedMonth}</p>
            </div>
            <p className='number'>{ridesRealtimeStat.month}</p>
          </div>
        </div>
      </main>
      <footer>
        <span>
          &#169; 2021-present LionTaxi. Built with{' '}
          <i className='fas fa-heart'></i> by{' '}
          <a href='https://twitter.com/elijahtrillionz'>Elijah Trillionz</a>
        </span>
      </footer>
    </div>
  );
};
